import {createContext} from "react";

export interface LoginUserDetail {
    username: string
    groupId: number
    groupName: string
}

export interface SystemSetting {
    isOpen: boolean;
    selectedMenuKey: Array<string>;
    selectedSubMenuKey: string;
    selectedMenuName: string;
    loginUserDetail: LoginUserDetail;

}

export type GlobalContent = {
    systemSetting: SystemSetting
    setSystemSetting: (c: SystemSetting) => void
}

export const initSystemSetting: SystemSetting = {
    isOpen: false,
    selectedMenuName: "N/A",
    selectedMenuKey: sessionStorage.getItem("selectedMenuKey") ? [sessionStorage.getItem("selectedMenuKey") + ""] : [],
    selectedSubMenuKey: sessionStorage.getItem("selectedSubMenuKey") ? sessionStorage.getItem("selectedSubMenuKey") + "" : "0-0",
    loginUserDetail: {groupId: 0, groupName: "", username: ""}
}


export const SystemSettingContext = createContext<GlobalContent>({
    systemSetting: initSystemSetting, // set a default value
    setSystemSetting: () => {
    },
})